<template>
  <ApplicationsRow two-columns>
    <div>
      <AhOvApplicationCard
        :no-top-left-border="activePartOneIndex === 0"
        :no-top-right-border="activePartOneIndex === firstItems.length - 1"
      >
        <template #top-content>
          <GenericH4>Överlåtaren</GenericH4>
          <PersonCard
            :name="currentCompanyName"
            :address="currentTenantCompanyInfo?.address || ''"
          >
            <!-- <template #name-icon>
              <LegalIcon v-if="activeCurrentTenantLegalRef" color="#e00201" />
            </template> -->
          </PersonCard>

          <MemberSelector
            :items="firstItems"
            :active-index="activePartOneIndex"
            @selectItemIndex="selectCurrentTenantIndex"
          />
        </template>
        <template v-if="activePartOneIndex === 0">
          <h3 class="name capitalize-first">
            {{ currentTenantCompanyInfo?.name || '' }}
          </h3>
          <CompanyModule :company="currentTenantCompanyInfo" />
          <hr class="divider" />
          <div class="card-content">
            <GenericH4>Företagets verksamhet</GenericH4>
            <p>{{ currentTenantCompanyInfo?.activities || '-' }}</p>
          </div>
          <hr class="divider" />
          <div class="card-content">
            <GenericH4>Lokalen</GenericH4>
            <ul class="apartment-info">
              <li>
                <b>Adress:</b> {{ apartment.address }},
                {{ apartment.postalCode }} {{ apartment.city }}
              </li>
              <li><b>Hyreskontraktnr.:</b> {{ apartment.contractNumber }}</li>
              <li><b>Antal rum:</b> {{ apartment.rooms }}</li>
              <li><b>Storlek i kvm:</b> {{ apartment.sqm }}</li>
              <li>
                <b>Innehaft sedan:</b>
                {{
                  new Date(apartment.contractStartDate).toLocaleDateString(
                    'sv-SE'
                  )
                }}
              </li>
            </ul>
          </div>
          <hr class="divider" />
          <div class="card-content">
            <GenericH4>
              Skäl för överlåtelsen samt den verksamhet som ska bedrivas i
              lokalen
            </GenericH4>
            <p>{{ application.reason.text }}</p>
          </div>
          <hr class="divider" />
          <OvApplicationCheckboxes
            :files="application.files"
            :attachments="application.attachments"
            :application="application"
            :application-id="application.id"
            :checked-files="application.checkedFiles"
            :other-checkboxes="otherCheckboxes"
            :application-status="application.landlordStatus"
            :is-transferor="true"
            @openFile="$emit('openFile', $event)"
            @checksChange="$emit('checksChange', $event)"
            @selectComment="$emit('selectComment', $event)"
          />
        </template>
        <template v-else>
          <h3 class="name capitalize-first">
            {{ activeCurrentTenant?.name || '' }}
          </h3>
          <ul class="apartment-info">
            <li><b>E-post:</b> {{ activeCurrentTenant?.email || '' }}</li>
            <li>
              <b>Telefonnr.:</b>
              {{ activeCurrentTenant.phone }}
            </li>
            <li><b>Adress:</b> {{ activeCurrentTenant?.address || '' }}</li>
            <li><b>Postnr.:</b> {{ activeCurrentTenant?.postalCode || '' }}</li>
            <li><b>Ort:</b> {{ activeCurrentTenant?.city || '' }}</li>
          </ul>
          <template v-if="activeCurrentTenant.protectedIdentity">
            <br />
            <h4 class="protectedIdentity-color" style="line-height: 1.6">
              Skyddad identitet
            </h4>
            <p>
              <b>{{ activeCurrentTenant.name }}</b> har skyddad identitet
            </p>
          </template>
          <template v-if="activeCurrentTenant.fullmaktName">
            <br />
            <h3 class="name capitalize-first">Fullmaktshavaren</h3>
            <ul class="apartment-info">
              <li>
                <b>Namn:</b>
                {{ activeCurrentTenant.fullmaktName }}
              </li>
              <li>
                <b>Personnr.:</b>
                {{ activeCurrentTenant.ssn }}
              </li>
              <li>
                <b>E-post:</b>
                {{ activeCurrentTenant.email }}
              </li>
              <li>
                <b>Telefonnr.:</b>
                {{ activeCurrentTenant.phone }}
              </li>
              <li>
                <b>Skyddad identitet:</b>
                {{
                  activeCurrentTenant.fullmaktProtectedIdentity ? 'Ja' : 'Nej'
                }}
              </li>
            </ul>
          </template>
          <!-- <template v-if="activeCurrentTenantLegalRef">
            <br />
            <LegalRef
              :name="activeCurrentTenantLegalRef.name"
              :url="activeCurrentTenantLegalRef.url"
            />
          </template> -->
          <template v-if="activeCurrentTenantPersonalInfo?.length">
            <hr class="divider" />
            <CompanyRoles :personal-infos="activeCurrentTenantPersonalInfo" />
          </template>
        </template>
      </AhOvApplicationCard>
      <ApplicationListCheck
        class="check-box"
        icon-url=""
        :is-checked="application.checkedFiles.includes('no_outstanding_debts')"
        :has-files="false"
        @checked="
          $emit('checksChange', {
            checked: $event,
            category: 'no_outstanding_debts'
          })
        "
        >Hyresgäst har inga utestående skulder</ApplicationListCheck
      >
    </div>
    <div>
      <AhOvApplicationCard
        :no-top-left-border="activePartTwoIndex === 0"
        :no-top-right-border="activePartTwoIndex === secondaryItems.length - 1"
      >
        <template #top-content>
          <GenericH4>Övertagaren</GenericH4>
          <PersonCard
            :name="secondCompanyName"
            :address="secondaryTenantCompanyInfo?.address || ''"
          >
            <!-- <template #name-icon>
              <LegalIcon v-if="activeSecondaryTenantLegalRef" color="#e00201" />
            </template> -->
          </PersonCard>

          <MemberSelector
            :items="secondaryItems"
            :active-index="activePartTwoIndex"
            @selectItemIndex="selectSecondaryTenantIndex"
          />
        </template>
        <template v-if="activePartTwoIndex === 0">
          <h3 class="name capitalize-first">
            {{ secondaryTenantCompanyInfo?.name || '' }}
          </h3>
          <CompanyModule
            :company="secondaryTenantCompanyInfo"
            :secondary-tenant="secondaryTenants[0]"
          />
          <hr class="divider" />
          <div class="card-content">
            <GenericH4>Företagets verksamhet</GenericH4>
            <p>{{ secondaryTenantCompanyInfo?.activities || '-' }}</p>
          </div>
          <hr class="divider" />
          <OvApplicationCheckboxes
            :files="application.files"
            :attachments="application.attachments"
            :application="application"
            :application-id="application.id"
            :checked-files="application.checkedFiles"
            :application-status="application.landlordStatus"
            :is-transferor="false"
            @openFile="$emit('openFile', $event)"
            @checksChange="$emit('checksChange', $event)"
            @selectComment="$emit('selectComment', $event)"
          />
        </template>
        <template v-else>
          <h3 class="name capitalize-first">
            {{ activeSecondaryTenant?.name || '' }}
          </h3>
          <ul class="apartment-info">
            <li><b>E-post:</b> {{ activeSecondaryTenant?.email || '' }}</li>
            <li>
              <b>Telefonnr.:</b>
              {{ activeSecondaryTenant.phone }}
            </li>
            <li><b>Adress:</b> {{ activeSecondaryTenant?.address || '' }}</li>
            <li>
              <b>Postnr.:</b> {{ activeSecondaryTenant?.postalCode || '' }}
            </li>
            <li><b>Ort:</b> {{ activeSecondaryTenant?.city || '' }}</li>
          </ul>
          <template v-if="activeSecondaryTenant.protectedIdentity">
            <br />
            <h4 class="protectedIdentity-color" style="line-height: 1.6">
              Skyddad identitet
            </h4>
            <p>
              <b>{{ activeSecondaryTenant.name }}</b> har skyddad identitet
            </p>
          </template>
          <template v-if="activeSecondaryTenant.fullmaktName">
            <br />
            <h3 class="name capitalize-first">Fullmaktshavaren</h3>
            <ul class="apartment-info">
              <li>
                <b>Namn:</b>
                {{ activeSecondaryTenant.fullmaktName }}
              </li>
              <li>
                <b>Personnr.:</b>
                {{ activeSecondaryTenant.ssn }}
              </li>
              <li>
                <b>E-post:</b>
                {{ activeSecondaryTenant.email }}
              </li>
              <li>
                <b>Telefonnr.:</b>
                {{ activeSecondaryTenant.phone }}
              </li>
              <li>
                <b>Skyddad identitet:</b>
                {{
                  activeSecondaryTenant.fullmaktProtectedIdentity ? 'Ja' : 'Nej'
                }}
              </li>
            </ul>
          </template>
          <!-- <template v-if="activeSecondaryTenantLegalRef">
            <br />
            <LegalRef
              :name="activeSecondaryTenantLegalRef.name"
              :url="activeSecondaryTenantLegalRef.url"
            />
          </template> -->
          <template v-if="activeSecondaryTenantPersonalInfo?.length">
            <hr class="divider" />
            <CompanyRoles :personal-infos="activeSecondaryTenantPersonalInfo" />
          </template>
        </template>
      </AhOvApplicationCard>
    </div>
  </ApplicationsRow>
</template>
<script>
//import { getLegalRef } from '@/utils/legalRef';

import PersonCard from '@/components/PersonCard.vue';
import MemberSelector from '@/components/MemberSelector.vue';
import OvApplicationCheckboxes from '@/components/OvApplicationCheckboxes.vue';
import AhOvApplicationCard from '@/components/AhOvApplicationCard.vue';
import ApplicationsRow from './ApplicationsRow.vue';
import CompanyModule from './CompanyModule.vue';
import CompanyRoles from './CompanyRoles.vue';
import GenericH4 from '@/components/GenericH4.vue';
import ApplicationListCheck from '@/components/ApplicationListCheck.vue';
//import LegalIcon from '@/components/Icons/LegalIcon.vue';
//import LegalRef from '@/components/LegalRef.vue';

export default {
  components: {
    CompanyModule,
    PersonCard,
    ApplicationsRow,
    AhOvApplicationCard,
    OvApplicationCheckboxes,
    MemberSelector,
    CompanyRoles,
    GenericH4,
    ApplicationListCheck
    //LegalIcon,
    //LegalRef
  },
  props: {
    application: {
      type: Object,
      required: true
    },
    otherCheckboxes: {
      type: Array,
      required: true
    }
  },
  emits: ['checksChange', 'openFile', 'selectComment'],

  data() {
    return {
      activePartOneIndex: 0,
      activePartTwoIndex: 0
      //getLegalRef
    };
  },
  computed: {
    firstItems() {
      return [
        {
          label: 'Företaget'
        },
        ...this.currentTenants.map((tenant, index) => ({
          ...tenant,
          label: `Firmatecknare ${index + 1}`,
          protectedIdentity: tenant.protectedIdentity
          //legalRef: getLegalRef(this.application, tenant.ssn)
        }))
      ];
    },
    secondaryItems() {
      return [
        {
          label: 'Företaget'
        },
        ...this.secondaryTenants.map((tenant, index) => ({
          ...tenant,
          label: `Firmatecknare ${index + 1}`,
          protectedIdentity: tenant.protectedIdentity
          //legalRef: getLegalRef(this.application, tenant.ssn)
        }))
      ];
    },
    apartment() {
      return this.application.apartment || {};
    },
    currentCompanyName() {
      const companyName = this.currentTenantCompanyInfo?.name || '';
      if (!this.currentTenantCompanyInfo?.deregistrationDate) {
        return companyName;
      }
      const date = new Date(
        this.currentTenantCompanyInfo.deregistrationDate
      ).toLocaleDateString('sv-SE');
      return `${companyName} <small style="color: var(--color-red)">(Inaktivt sedan ${date})</small>`;
    },
    secondCompanyName() {
      const companyName = this.secondaryTenantCompanyInfo?.name || '';
      if (!this.secondaryTenantCompanyInfo?.deregistrationDate) {
        return companyName;
      }
      const date = new Date(
        this.secondaryTenantCompanyInfo.deregistrationDate
      ).toLocaleDateString('sv-SE');
      return `${companyName} <small style="color: var(--color-red)">(Inaktivt sedan ${date})</small>`;
    },
    secondaryTenants() {
      return this.application.secondaryTenants;
    },
    currentTenants() {
      return this.application.currentTenants;
    },
    activeCurrentTenant() {
      return this.currentTenants[this.activePartOneIndex - 1];
    },
    // activeCurrentTenantLegalRef() {
    //   const legalRefUrl = this.getLegalRef(
    //     this.application,
    //     this.activeCurrentTenant?.ssn
    //   );
    //   if (!legalRefUrl) {
    //     return null;
    //   }
    //   return {
    //     name: this.activeCurrentTenant.name,
    //     url: legalRefUrl
    //   };
    // },
    activeSecondaryTenant() {
      return this.secondaryTenants[this.activePartTwoIndex - 1];
    },
    // activeSecondaryTenantLegalRef() {
    //   const legalRefUrl = this.getLegalRef(
    //     this.application,
    //     this.activeSecondaryTenant?.ssn
    //   );
    //   if (!legalRefUrl) {
    //     return null;
    //   }
    //   return {
    //     name: this.activeSecondaryTenant.name,
    //     url: legalRefUrl
    //   };
    // },
    currentTenantCompanyInfo() {
      return this.getCompanyInfo(this.currentTenants[0].organizationNumber);
    },
    activeCurrentTenantPersonalInfo() {
      return this.getPersonalInfo(this.activeCurrentTenant.ssn);
    },
    secondaryTenantCompanyInfo() {
      return this.getCompanyInfo(this.secondaryTenants[0].organizationNumber);
    },
    activeSecondaryTenantPersonalInfo() {
      return this.getPersonalInfo(this.activeSecondaryTenant.ssn);
    }
  },
  methods: {
    getCompanyInfo(orgNr) {
      return this.application.companies[orgNr];
    },
    getPersonalInfo(ssn) {
      return this.application.personals[ssn];
    },
    selectSecondaryTenantIndex(index) {
      this.activePartTwoIndex = index;
    },
    selectCurrentTenantIndex(index) {
      this.activePartOneIndex = index;
    }
  }
};
</script>
<style scoped>
.divider {
  background-color: #e4e5e8;
  margin: 2rem 0;
  border: none;
  height: 1px;
}

.apartment-info li {
  font-weight: 400;
  font-size: 13px;
  line-height: 1.6;
}
.apartment-info li b {
  font-weight: 600;
}

.check-box {
  font-size: 1.4rem;
  margin-top: 1rem;
  color: var(--color-dark-blue);
}
</style>
